<template>
  <div class='outline-echart'>
    <div v-if='echartArray.ex || echartArray.alarm || echartArray.normalAbnormal'>
      <div v-if='echartArray.ex'>
        <Header class='header-echart' :leftIcon='exAnalConfig.leftIcon' :rightIcon='exAnalConfig.rightIcon' />
        <LineEchart :className="'echarts'" :chartData='echartArray.ex' />
      </div>

      <div v-if='echartArray.alarm'>
        <Header class='header-echart' :leftIcon='alarmAnalConfig.leftIcon' :rightIcon='alarmAnalConfig.rightIcon' />
        <LineEchart :className="'echarts'" :chartData='echartArray.alarm' />
      </div>

      <div v-if='echartArray.normalAbnormal'>
        <Header class='header-echart' :leftIcon='proportionAnalConfig.leftIcon'
                :rightIcon='proportionAnalConfig.rightIcon' />
        <pieEchart :chartData='echartArray.normalAbnormal' />
      </div>
    </div>
    <div v-else style='margin-top:40px'>
      <el-empty :description="$t('integration.no_monitoring_point_data')"></el-empty>
    </div>

    <AnalItem :isShow.sync='isShow' :title="$t('integration.exception_analysis_settings')" :config='exAnalSetting'
              :defaultSetting='setting' ref='ex' @impl="handleImpl('ex', $event.ex)"></AnalItem>
    <AnalItem :isShow.sync='alarmAnalShow' :title="$t('integration.alarm_trigger_analysis_settings')"
              :config='alarmAnalSetting' :defaultSetting='setting' ref='alarm'
              @impl="handleImpl('alarm', $event.alarm)">
    </AnalItem>
    <AnalItem :isShow.sync='proportionAnalShow' :title="$t('integration.normal_abnormal_proportion_analysis_setting')"
              :config='proportionAnalSetting' :defaultSetting='setting' ref='normalAbnormal'
              @impl="handleImpl('normalAbnormal', $event.normalAbnormal)"></AnalItem>
  </div>
</template>
<script>
import Header from '../../Header.vue'
import LineEchart from '@/components/echart/LineBarEchart.vue'
import pieEchart from '@/components/echart/pieEchart.vue'
import bus from '@/utils/bus'
import { alarmAnal, analProportion, exAnal } from '@/api/modules/monitorPoint'
import AnalItem from '../../../../../../dialog/analItem.vue'
import setting from '../../default/setting'
import { formatEchart, tooltipMinFormat } from '@/utils/echart'
// 各个分析的设置dialog显示配置
import { alarmAnalSetting, exAnalSetting, proportionAnalSetting } from './config/analDialogSetting'
// header的图标配置 包括点击事件也会配置在里面
import { alarmAnalConfig, exAnalConfig, proportionAnalConfig } from './config/analConfig'
import defaultSetting from '@/pages/dataBoard/deviceMonitor/dataAnalysis/config/defaultSetting'

export default {
  components: {
    Header,
    LineEchart,
    AnalItem,
    pieEchart
  },
  data () {
    return {
      setting,
      exAnalConfig,
      alarmAnalConfig,
      proportionAnalConfig,
      alarmAnalSetting,
      proportionAnalSetting,
      echartArray: {},
      // 显隐会在配置文件内控制
      // 异常分析设置显隐
      isShow: false,
      // 报警触发设置显隐
      alarmAnalShow: false,
      // 正常异常比例分析显隐
      proportionAnalShow: false,
      // 已选中数据 会通过bus改变 保存选中监测点id文本
      checkedData: '',
      config: {}
    }
  },
  computed: {
    exAnalSetting () {
      return exAnalSetting
    }
  },

  mounted () {
    const queue = []
    // 左侧保存数据
    bus.$on('saveMonitorPoint', rows => {
      this.checkedData = rows.map(item => item.id).join(',')
      if (queue.length) {
        queue.forEach(() => {
          const config = queue.shift()
          this.handleConfig(config)
        })
      } else {
        if (Object.keys(this.config).length) {
          this.handleConfig(this.config)
        }
      }
    })

    // 有新的配置值需要更新  直接拿到配置请求
    bus.$on('analSetConfig', config => {
      // 空则将配置入队
      if (!this.checkedData) {
        queue.push(config)
      } else {
        // 非空则请求
        this.handleConfig(config)
      }

      // 设置dialog的默认值
      this.$refs.ex.setConfig(config)
      this.$refs.alarm.setConfig(config)
      this.$refs.normalAbnormal.setConfig(config)
    })

    bus.$on('reflashData', ids => {
      this.handleConfig(this.config, ids)
    })

    // bus.$on('saveMonitorPoint', (rows) => {
    //   console.log("@",rows);
    //   // 接收到数据
    //   this.checkedData=rows.map(item=>item.id).join(',');
    //   this.handleConfig(this.config);
    // });
  },
  methods: {
    // 根据配置请求echart ids可有可无 有则指定id刷新图表
    handleConfig (config, ids) {
      if (!Object.keys(config).length) {
        config = defaultSetting
      }
      this.config = config
      this.echartArray = {}

      if (config.alarm) {
        // 请求alram图表
        this.getAlarmAnal(config.alarm, ids)
      }
      if (config.ex) {
        // 请求ex图
        this.getExAnal(config.ex, ids)
      }
      if (config.normalAbnormal) {
        // 请求正常异常比例
        this.getProportion(config.normalAbnormal, ids)
      }
    },
    // 对后端返回的结果进行格式化
    handleResult (setting, result, field = {}) {
      const curYearObj = JSON.parse(JSON.stringify(field))
      const lastYearObj = JSON.parse(JSON.stringify(field))
      let chart, target, contrast
      // 在字段后面都带上日期
      Object.keys(curYearObj).forEach(key => {
        const item = curYearObj[key]
        if (setting.endTime) {
          const curYear = setting.endTime.split('-')[0]
          item.name = `${item.name}(${curYear})`
        } else if (setting.time) {
          const curYear = setting.time.split('-')[0]
          item.name = `${item.name}(${curYear})`
        }
      })
      Object.keys(lastYearObj).forEach(key => {
        const item = lastYearObj[key]
        if (setting.endTime) {
          const lastYear = setting.endTime.split('-')[0] * 1 - 1 + ''
          item.name = `${item.name}(${lastYear})`
        } else if (setting.time) {
          const lastYear = setting.time.split('-')[0] * 1 - 1 + ''
          item.name = `${item.name}(${lastYear})`
        }
      })

      switch (setting.method) {
        case 0:
          chart = formatEchart(result.stats, field)
          break
        case 1:
          contrast = formatEchart(result.yoy.contrast, lastYearObj)
          target = formatEchart(result.yoy.target, curYearObj)
          target.series = [...contrast.series, ...target.series]
          chart = target
          break
        case 2:
          chart = formatEchart([result.ringCompare.contrast, result.ringCompare.target], field)
          break
      }
      return chart
    },
    async handleImpl (type, param) {
      switch (type) {
        case 'ex':
          (await this.getExAnal(param)) && this.$message.success($t('integration.successful_execution'))
          break
        case 'alarm':
          (await this.getAlarmAnal(param)) && this.$message.success($t('integration.successful_execution'))
          break
        case 'normalAbnormal':
          (await this.getProportion(param)) && this.$message.success($t('integration.successful_execution'))
          break
      }
    },
    async getExAnal (ex, ids) {
      await exAnal({ carrierIds: ids || this.checkedData, ...ex }).then(({ result }) => {
        if (result) {
          const chart = this.handleResult(ex, result, {
            yAxis: {
              name: $t('integration.abnormal_duration'),
              type: 'bar',
              yAxisIndex: 0,
              formatter: value => {
                // 显示不完+...
                value = value + ''
                if (value.length > 5) {
                  value = value.substr(0, 5) + '...'
                }
                return value + $t('public.minute')
              }
            },
            series: {
              name: $t('integration.number_of_exceptions'),
              type: 'line',
              yAxisIndex: 1,
              formatter: '{value}次'
            }
          })
          chart.tooltip = {
            formatter: tooltipMinFormat
          }
          this.$delete(this.echartArray, 'ex')
          this.$nextTick(() => this.$set(this.echartArray, 'ex', chart))
        }
      })
      return true
    },
    async getAlarmAnal (alarm, ids) {
      await alarmAnal({ carrierIds: ids || this.checkedData, ...alarm }).then(({ result }) => {
        if (result) {
          const chart = this.handleResult(alarm, result, {
            yAxis: {
              name: $t('integration.alarm_trigger_times'),
              type: 'bar',
              formatter: value => `${value}${$t('integration.times')}`
            }
          })
          this.$delete(this.echartArray, 'alarm')
          this.$nextTick(() => this.$set(this.echartArray, 'alarm', chart))
        }
      })
      return true
    },
    async getProportion (normalAbnormal, ids) {
      let res
      try {
        res = await analProportion({ carrierIds: ids || this.checkedData, ...normalAbnormal })
      } catch {
        return false
      }
      const result = res.result
      if (res.state.code === 200 && result && result.normalAbnormal) {
        result.normalAbnormal = result.normalAbnormal.map(item => {
          item.name = $t(`integration.${item.name}`)
          return item
        })
        const pieData = {
          pieSeries: result.normalAbnormal,
          rest: {
            title: $t('integration.normal_abnormal_proportion'),
            name: $t('integration.normal_abnormal_proportion'),
            isTip: true,
            labelLine: {
              show: true
            },
            label: {
              show: true
            },
            legend: {
              show: false
            }
          }
        }
        pieData.tooltip = {
          formatter: tooltipMinFormat
        }

        this.$delete(this.echartArray, 'normalAbnormal')
        this.$nextTick(() => this.$set(this.echartArray, 'normalAbnormal', pieData))
        return true
      } else {
        return false
      }
    }
  },
  beforeDestroy () {
    bus.$off('selectRows')
    bus.$off('analSetConfig')
    bus.$off('reflashData')
    bus.$off('saveMonitorPoint')
  }
}
</script>

<style lang='scss' scoped>
.outline-echart {
  height: 100%;
  margin: 0 5px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  overflow: auto;

  .echart-content {
    width: 100%;
    height: 400px;
  }

  .header-echart {
    margin-top: -1px;
    border-top: 1px solid #cccccc;
  }

  .echarts {
    width: 100%;
    height: 360px !important;
  }
}
</style>
